import React, { useState, useEffect } from 'react';
import DistP1 from './components/DistP1';
import DistP2 from './components/DistP2';
import DistP3 from './components/DistP3';
import { getAllApmcDocument,  getExistedSchemesAplication, submitApmcApproveRejectApplication, submitApmcFiles } from '../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { toast,ToastContainer } from "react-toastify";
import SchemesDownload from '../DownloadForm/Download';

 
 
// STEPS FOR NEXT
 
const District: React.FC = () => {
  const token = useSelector((state:any)=>state.auth.token);
  const userDetail = useSelector((state:any)=>state.auth.userDetails)
  const roleIdentifier = userDetail.Role.Role_Identifier;
  const navigate = useNavigate();
  const location = useLocation()
  const applicationId = location.state?.applicationId;
  const id= location.state?.id;
  const [step, setStep] = useState<number>(1);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editFieldValues, setEditFieldValues] = useState<{ [key: string]: any }>({});
  const [editFiles, setEditFiles] = useState<{ [key: string]: File | null }>({});
  const [editComment, setEditComment] = useState<string>("");
  const [apmcOptions, setApmcOptions] = useState<any>([]);
  const [districtOptions , setDistrictOptions] = useState<any>([]);
  const [talukaOptions , setTalukaOptions] = useState<any>([]);
  const [existData ,setExistData] = useState<any | null>(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [transaction , setTransaction] = useState<any[]>([])
  const [formData, setFormData] = useState({
 
     //APMCp1 files
      district:  "",
    apmcName: "",
    taluka: "",
    copyOfMarketCommitteEstDet : null as any,
    certOfMarketCommitteCategory: null as any,
    scheme: "",
    purpose:   "",
    planProjectCost:  null as any,
    estimatePlanConstruction:null as any,
    estimateProjectCostAmount:null as any,
    percentOfProjCostEligible:  "",
    planEstimateByApprovedPE: null as any,
    isExistingConstructionOnProjSite: "",
    toolsEquipQuotations:  null as any,
    estimateCertifiedByGovtEngineer:  null as any,
 
     // APMCp2 file fields
     permissionFromAuthority: null as any,
     insuranceUndertakingPostConstruction: null as any,
     auditUndertakingAfterAssistance: null as any,
     schemeConditionsUndertaking: null as any,
     jointAccountAssistanceUndertaking: null as any,
     noPriorAssistanceUndertaking: null as any,
     registerMaintenanceUndertaking: null as any,
     repaymentOnViolationUndertaking: null as any,
     constructionCompletionCertificate: null as any,
     noOutstandingDuesUndertaking: null as any,
     constructionProcurementETendering: null as any,
     goodsProcurementETendering: null as any,
     
     // APMCp3 file fields
     isLandOwnedByMarketingCommitee: null as any,
     hasAssistanceApproved: "",
     assistanceDetails: [
       {
         date: "",
         scheme: "",
         purpose: "",
         sanctionedAmount: "",
        totalAmount: "",
        hasExceeded5Crore: ""
       }
     ],
     
     isMarktingCommitteeLocatedInGeneral: "",
     marktingCommitteeLocatedInGeneral: null as any,
     isMarktingCommFinanciallyCapableOfExpense: "",
     marktingCommFinanciallyCapableOfExpense: null as any,
     incExpenditureForLast3Yrs: null as any,
     auditIncExpenditureForLast3Yrs: null as any,
     existingFarmerFacilities: null as any,
     marketCessIncome5YrsLast: null as any,
     marketCessIncome5YrsNext: null as any,
   });
   const [siteInspectionPhotos,setSiteInspectionPhotos]=useState<any[]>([]);

   
   
   const [updatedFields, setUpdatedFields] = useState({});
  
   const [isLicenseUploaded , setIsLicenseUploaded] = useState(false)

   
  // DROPDOWN OF 12no.
  const [assistanceDetails, setAssistanceDetails] = useState([
    {
      date: "",
      scheme: "",
      purpose: "",
      sanctionedAmount: "",
      totalAmount:"",
      hasExceeded5Crore:""
    }
  ]);

  

  // -----------------------------------Validations------------------------------------

  const [validationErrors, setValidationErrors] = useState<{ [key: string]: boolean }>({});
  const [isValidationActive, setIsValidationActive] = useState(false);

  useEffect(() => {
  // Clear validation state when location/route changes (in-memory only)
  setValidationErrors({});
  setIsValidationActive(false);
}, [location.pathname]);
  
  


//--------------------------------APMC,DISTRICT,TALUKA---------------------------------------
 const getExistedApplication = async () => {
   try {
        
        const response = await getExistedSchemesAplication(token, applicationId, id);
      
        if (response?.success) {
         
           setExistData(response?.data);
           // normalize/set site inspection photos into local state (API may return object keyed by field names)
           setSiteInspectionPhotos(response?.data?.siteInspectionPhotos || []);
           setTransaction(response?.data?.ApmcSchemeTransaction || []);
        }
      } catch (error) {
      
      }
    }

//----------------------------------FETCH API----------------------------------

   useEffect(()=>{
 
     getExistedApplication();
  },[])

    useEffect(() => {
    
        setFormData(prev => ({
          ...prev,
          district: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "District")?.value || "",
          apmcName: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "apmcName")?.value || "",
          taluka: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "Taluka")?.value || "",
          copyOfMarketCommitteEstDet: existData?.annexureOne?.copyOfMarketCommitteEstDet?.data ? existData?.annexureOne?.copyOfMarketCommitteEstDet?.data[0] : null,
          certOfMarketCommitteCategory: existData?.annexureOne?.certOfMarketCommitteCategory?.data ? existData?.annexureOne?.certOfMarketCommitteCategory?.data[1] : null,
          // scheme: existData?.annexureOne?.purposeOfAssistance?.data ? existData?.annexureOne?.purposeOfAssistance?.data?.find((item: any) => item.fieldName === "scheme")?.value : "",
          // purpose: existData?.annexureOne?.purposeOfAssistance?.data ? existData?.annexureOne?.purposeOfAssistance?.data?.find((item: any) => item.fieldName === "purpose")?.value : "",
          planProjectCost: existData?.annexureOne?.estimateProjectCost?.data[1] ? existData?.annexureOne?.estimateProjectCost?.data[1] : null,
      estimateProjectCostAmount:existData?.annexureOne?.estimateProjectCost?existData?.annexureOne?.estimateProjectCost?.data?.find((item: any) => item.fieldName === "estimateProjectCostAmount")?.value : "",
        estimatePlanConstruction:existData?.annexureOne?.estimatePlanConstruction?existData?.annexureOne?.estimatePlanConstruction?.data[0]:null,
      percentOfProjCostEligible: existData?.annexureOne?.percentOfProjCostEligible?.data ? existData?.annexureOne?.percentOfProjCostEligible?.data[0]?.value : "",
          planEstimateByApprovedPE: existData?.annexureOne?.planEstimateByApprovedPE?.data ? existData?.annexureOne?.planEstimateByApprovedPE?.data[0] : null,
          isExistingConstructionOnProjSite: existData?.annexureOne?.isExistingConstructionOnProjSite?.data ? existData?.annexureOne?.isExistingConstructionOnProjSite?.data[0]?.value : "",
          toolsEquipQuotations: existData?.annexureOne?.toolsEquipQuotations?.data ? existData?.annexureOne?.toolsEquipQuotations?.data[0] : null,
          estimateCertifiedByGovtEngineer: existData?.annexureOne?.estimateCertifiedByGovtEngineer?.data ? existData?.annexureOne?.estimateCertifiedByGovtEngineer?.data[0] : null,
          permissionFromAuthority: existData?.annexureTwo?.permissionFromAuthority?.data ? existData?.annexureTwo?.permissionFromAuthority?.data[0] : null,
          insuranceUndertakingPostConstruction: existData?.annexureTwo?.insuranceUndertakingPostConstruction?.data ? existData?.annexureTwo?.insuranceUndertakingPostConstruction?.data[0] : null,
          auditUndertakingAfterAssistance: existData?.annexureTwo?.auditUndertakingAfterAssistance?.data ? existData?.annexureTwo?.auditUndertakingAfterAssistance?.data[0] : null,
          schemeConditionsUndertaking: existData?.annexureTwo?.schemeConditionsUndertaking?.data ? existData?.annexureTwo?.schemeConditionsUndertaking?.data[0] : null,
          jointAccountAssistanceUndertaking: existData?.annexureTwo?.jointAccountAssistanceUndertaking?.data ? existData?.annexureTwo?.jointAccountAssistanceUndertaking?.data[0] : null,
          noPriorAssistanceUndertaking: existData?.annexureTwo?.noPriorAssistanceUndertaking?.data ? existData?.annexureTwo?.noPriorAssistanceUndertaking?.data[0] : null,
          registerMaintenanceUndertaking: existData?.annexureTwo?.registerMaintenanceUndertaking?.data ? existData?.annexureTwo?.registerMaintenanceUndertaking?.data[0] : null,
          repaymentOnViolationUndertaking: existData?.annexureTwo?.repaymentOnViolationUndertaking?.data ? existData?.annexureTwo?.repaymentOnViolationUndertaking?.data[0] : null,
          constructionCompletionCertificate: existData?.annexureTwo?.constructionCompletionCertificate?.data ? existData?.annexureTwo?.constructionCompletionCertificate?.data[0] : null,
          noOutstandingDuesUndertaking: existData?.annexureTwo?.noOutstandingDuesUndertaking?.data ? existData?.annexureTwo?.noOutstandingDuesUndertaking?.data[0] : null,
          constructionProcurementETendering: existData?.annexureTwo?.constructionProcurementETendering?.data ? existData?.annexureTwo?.constructionProcurementETendering?.data[0] : null,
          goodsProcurementETendering: existData?.annexureTwo?.goodsProcurementETendering?.data ? existData?.annexureTwo?.goodsProcurementETendering?.data[0] : null,
          isLandOwnedByMarketingCommitee: existData?.annexureThree?.isLandOwnedByMarketingCommitee?.data ? existData?.annexureThree?.isLandOwnedByMarketingCommitee?.data[0] : null,
          hasAssistanceApproved: existData?.annexureThree?.hasAssistanceApproved?.data[0] ? existData?.annexureThree?.hasAssistanceApproved?.data[0]?.value : "",
          assistanceDetails: existData?.annexureThree?.hasAssistanceApproved?.data[0]?.value=== "yes"
            ? existData?.annexureThree?.hasAssistanceApproved?.data
              .filter((item: any) => item.fieldName && item.fieldName.startsWith("details_"))
              .sort((a: any, b: any) => {
                const numA = parseInt(a.fieldName.split("_")[1], 10);
                const numB = parseInt(b.fieldName.split("_")[1], 10);
                return numA - numB;
              })
              .map((item: any) => ({
                date: item.value?.date || "",
                scheme: item.value?.scheme || "",
                purpose: item.value?.purpose || "",
                sanctionedAmount: item.value?.amount || "",
                totalAmount: item.value?.totalAmount || "",  
                hasExceeded5Crore: item.value?.hasExceeded5Crore || "" 
              }))
            : [],
          isMarktingCommitteeLocatedInGeneral: existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data ? existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data?.find((item: any) => item.fieldName === "isApproved")?.value : "",
          marktingCommitteeLocatedInGeneral: existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data ? existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data[1] : null,
          isMarktingCommFinanciallyCapableOfExpense: existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data ? existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data?.find((item: any) => item.fieldName === "isApproved")?.value : "",
          marktingCommFinanciallyCapableOfExpense: existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data ? existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data[1] : null,
          incExpenditureForLast3Yrs: existData?.annexureThree?.incExpenditureForLast3Yrs?.data ? existData?.annexureThree?.incExpenditureForLast3Yrs?.data[0] : null,
          auditIncExpenditureForLast3Yrs: existData?.annexureThree?.auditIncExpenditureForLast3Yrs?.data ? existData?.annexureThree?.auditIncExpenditureForLast3Yrs?.data[0] : null,
          existingFarmerFacilities: existData?.annexureThree?.existingFarmerFacilities?.data ? existData?.annexureThree?.existingFarmerFacilities?.data[0] : null,
          marketCessIncome5YrsLast: existData?.annexureThree?.marketCessIncome5YrsLast?.data ? existData?.annexureThree?.marketCessIncome5YrsLast?.data[0] : null,
          marketCessIncome5YrsNext: existData?.annexureThree?.marketCessIncome5YrsLast?.data ? existData?.annexureThree?.marketCessIncome5YrsLast?.data[1] : null,
           designationRepresentative: existData?.annexureThree?.designationRepresentative?.data ? existData?.annexureThree?.designationRepresentative?.data?.find((item: any) => item.fieldName === "designationRepresentative")?.value : "",
            nameRepres: existData?.annexureThree?.nameRepres?.data ? existData?.annexureThree?.nameRepres?.data?.find((item: any) => item.fieldName === "nameRepres")?.value : "",
        }));
      
        setAssistanceDetails(
          existData?.annexureThree?.hasAssistanceApproved?.data[0]?.value === "yes"
            ? existData?.annexureThree?.hasAssistanceApproved?.data
                .filter((item: any) => item.fieldName && item.fieldName.startsWith("details_"))
                .sort((a: any, b: any) => {
                  // Sort by the number after "details_"
                  const numA = parseInt(a.fieldName.split("_")[1], 10);
                  const numB = parseInt(b.fieldName.split("_")[1], 10);
                  return numA - numB;
                })
                .map((item: any) => ({
                  date: item.value?.date || "",
                  scheme: item.value?.scheme || "",
                  purpose: item.value?.purpose || "",
                  sanctionedAmount: item.value?.amount || "",
                  totalAmount: item.value?.totalAmount || "",  
                  hasExceeded5Crore: item.value?.hasExceeded5Crore || "" 
                }))
            : []
        );
        setSiteInspectionPhotos(
          existData?.siteInspectionPhotos || []
        );
    }, [existData]);

      const[pdfData, setPdfData] = React.useState<any>(null);




  const handleNext = (): void => {
    if (step < 3) setStep(step + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };
 
  const handleBack = (): void => {
    if (step > 1) setStep(step - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };


  
    const handleFileinputChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
     
    const { name, files } = e.target;

     if (files && files.length > 0) {
       const file = files[0];
       const fileName = file.name;
       
       
        handleFileUpload(fileName,file, fieldName ,formData[fieldName]?.docId );
        
      }
  
  
  };
  
  const handleFileUpload = async (documentName: string,file:any , fieldName:string , docId?: string | null) => {
      // if (!formData[fieldName]) return;
   

      const formData = new FormData();
      formData.append("file", file );
      formData.append("documentName", fieldName);
      formData.append("fieldName", documentName);
      formData.append("applicationId", applicationId);
      formData.append("schemeId",existData?.scheme?.id)
   
      setIsLicenseUploaded(true);
      try {
        const res = await submitApmcFiles(formData, token, docId);
        setIsLicenseUploaded(false);
      
        
        if(res.success==false)
          {
          toast.error(res?.message, { position: "top-right" })
    
        }
        else if (res.success && res.docId) {
       
       setFormData(prev => ({
          ...prev,
          [fieldName]: {
            docId: res.docId,
            documentName: documentName,
            fileName: file.name,
          }
        }));
        toast.success(res?.message, { position: "top-right" })
      }
      } catch (error) {
        setIsLicenseUploaded(false);
         toast.error("File Upload Failed", { position: "top-right" })
      } 
    };


// -------------------------------------Handle Inputs-------------------------------------
const inspectionPhotosChange =async ( e: React.ChangeEvent<HTMLInputElement>,fieldName: string) => {
  const { name,files } = e.target;
  if (!files || files.length === 0) {
    return;
   
  }
  const file = files[0];
  const formData = new FormData();
      formData.append("file", file );
      formData.append("documentName", name);
      formData.append("fieldName", fieldName);
      formData.append("applicationId", applicationId);
      formData.append("schemeId",existData?.scheme?.id)
      let docId= siteInspectionPhotos[fieldName]?.docId ? siteInspectionPhotos[fieldName]?.docId : null;
   
      setIsLicenseUploaded(true);
      try {
        const res = await submitApmcFiles(formData, token, docId);
        setIsLicenseUploaded(false);
      
        
        if(res.success==false)
          {
          toast.error(res?.message, { position: "top-right" })
    
        }
        else if (res.success && res.docId) {
        setSiteInspectionPhotos((prevPhotos) => ({
       ...prevPhotos,
       [fieldName]:{
          docId: res.docId,
          documentName: name,
       }
        }));

        toast.success(res?.message, { position: "top-right" })
      }
      } catch (error) {
        setIsLicenseUploaded(false);
         toast.error("File Upload Failed", { position: "top-right" })
      } 
};

  const handleFileChange = async(e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {

    const updatedDataLs = JSON.parse(localStorage.getItem("updatedFields")) || {};
   

  const { name, files } = e.target;

   if (files && files.length > 0) {
     const file = files[0];
     const fileName = file.name;
      // setItReturns((prev) => ({ ...prev, [name]: files[0] }));
      // setDisableButtonNext(true)
      let docId:any;
     
      let  docIdToUpdate;
      
      if(updatedDataLs && updatedDataLs[fieldName])
       docIdToUpdate = updatedDataLs?.[fieldName]?.docId;

      
      
      const userData= existData?.annexureOne?.[fieldName]?.transaction?.find(data=>data.transactionBy == userDetail.Role.Role_Identifier && data.status==existData.status)
   
  
      let userExistDocId;
      if(userData)
      {
      
        const docData = userData?.newValue.find(data=>data?.fieldName == name);
        
        userExistDocId = docData?.fieldValue ? docData.fieldValue : null;
       
      }
      docId= docIdToUpdate ? docIdToUpdate : userExistDocId ? userExistDocId : docId;


      const docIdUpdated = await handleUpload(name,file, fieldName ,docId );
     
      return docIdUpdated
      // setDisableButtonNext(false)
    }
    
    

   
};

const handleUpload = async (documentName: string,file:any , fieldName:string , docId?: string | null, ) => {
    // if (!formData[fieldName]) return;
 
    const formData = new FormData();
    formData.append("file", file );
    formData.append("documentName", documentName );
    formData.append("fieldName", fieldName);
    formData.append("applicationId", applicationId);
    formData.append("schemeId",id)
 
 
    try {
      setUploadLoading(true);
      const res = await submitApmcFiles(formData, token, docId);
    
      
      if(res.success==false)
        {
           toast.error(res?.message, { position: "top-right" })

  
      }
      else if (res.success && res.docId) {

      setUpdatedFields(prev => {
          const updated = {
            ...prev,
            [fieldName]: {
              docId: res.docId,
              documentName: documentName,
              fileName: file.name
            }
          };

          localStorage.setItem("updatedFields", JSON.stringify(updated));

          return updated;
        });
        toast.success(res?.message, { position: "top-right" })

        return res.docId

    }
    return null;
    } catch (error) {
         toast.error("File Upload Failed", { position: "top-right" })
         return null;

    } finally {
      setUploadLoading(false);

    }
  };
const handleEdInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  
};

const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value } = e.target;
  if (name === "percentage") {
    let val = Number(value);
    if (val > 100) val = 100;
    if (val < 0) val = 0;
    setUpdatedFields(prev => ({
      ...prev,
      percentage: val === 0 && value === "" ? "" : String(val)
    }));
  } else {

    setUpdatedFields(prev => ({
      ...prev,
      [name]: value,
    }));
  }
};

// Preview File

const handlePreviewFile = (fileData: { base64: string, name: string, type: string }) => {
  if (fileData) {
    const fileWindow = window.open();
    if (fileWindow) {
      if (fileData.type.includes('pdf')) {
        fileWindow.document.write(
          `<iframe src="${fileData.base64}" width="100%" height="100%" style="border:none;"></iframe>`
        );
      } else {
        fileWindow.document.write(
          `<img src="${fileData.base64}" alt="${fileData.name}" style="max-width:100%;" />`
        );
      }
    }
  }

};


  //----------------------------------Update button of every Field-------------------------------------------

  // 🔁 Shared update-related state


// ✅ Shared handler to update values
const handleEditChange = (name: string, value: any) => {
  setEditFieldValues(prev => ({ ...prev, [name]: value }));
};

const handleEditFileChange = (name: string, file: File | null) => {
  setEditFiles(prev => ({ ...prev, [name]: file }));
};



const fetchallDocs = async (): Promise<ArrayBuffer | null> => {
    try {
      const response = await getAllApmcDocument(applicationId, token, "apmc");
 
  
      // If API already returns ArrayBuffer (Axios with responseType:"arraybuffer")
      // then response is already an ArrayBuffer
      // otherwise, if response is Blob, convert it
      let buffer: ArrayBuffer;
  
      if (response instanceof Blob) {
        buffer = await response.arrayBuffer();
      } else {
        buffer = response as ArrayBuffer;
      }
  
      // Debug: preview PDF
      // const blob = new Blob([buffer], { type: "application/pdf" });
      // const url = URL.createObjectURL(blob);
      // window.open(url);
       setPdfData(buffer); // Store the ArrayBuffer in state
      return buffer; // ✅ return ArrayBuffer
    } catch (error) {
  
      return null; // ✅ safer than {}
    }
  };
 const handleFinalSubmit = async (status: string, appStatusLevel: string) => {
          
    
        
    
            
    
            try {
                const submitFormData = {
                    status: status,
                    appStatusLevel: appStatusLevel,
                    applicationId: applicationId,
                    schemeId: existData?.scheme?.id,
                    applicationType: "scheme"
                };
    
         
    
                const submitData = await submitApmcApproveRejectApplication(submitFormData, token);
    
                if (submitData.success) {
                    let successMessage = "";
                    if (submitData.data.status === "reject") {
                        successMessage = "Query raised successfully!";
                        toast.warning(successMessage, { position: "top-right" });
                    } else if (submitData.data.status === "permanentReject") {
                        successMessage = "Application permanently rejected!";
                        toast.error(successMessage, { position: "top-right" });
                    } else if (submitData.data.status === "approvedUnsigned") {
                        successMessage = "Application approved successfully!";
                        toast.success(successMessage, { position: "top-right" });
                    } else {
                        successMessage = "Form submitted successfully!";
                        toast.success(successMessage, { position: "top-right" });
                    }
    
                    setTimeout(() => {
                        navigate("/apmc-application");
                    }, 2000);
                } else {
                    toast.error("Submission failed. Please try again.", {
                        position: "top-right"
                    });
                }
    
            } catch (error) {
         
                toast.error("An error occurred during submission.", {
                    position: "top-right"
                });
            }
        };
  useEffect(() => {
    fetchallDocs();
    }
    , [applicationId, token]);


  return (
      
  <div className="page-wrapper ">
  {/* Fixed Header + Stepper */}
  <div className="position-fixed page-wrapper start-0 end-0 z-3 border-bottom"
    style={{
    padding: "1rem",
    backgroundColor: "#f8f9fa", // or specify same color code
  }}>

    <h1>
      Application for Scheme - પરિશિષ્ટ-બે (Annexure 2)
    </h1>

    <div className="m-3 d-flex justify-content-center align-items-center w-100">

  {/* Step 1 */}
  <div
    className="rounded-circle d-flex justify-content-center align-items-center"
    style={{
      height: "50px",
      width: "50px",
      backgroundColor: step > 1 ? '#1b84ff' : 'white',
      border: step === 1 ? '2px solid #1b84ff' : '1px solid lightblue',
      color: step > 1 ? 'white' : '#0d6efd',
      fontSize:"1.5rem"
    }}
  >
    {step > 1 ? <i className="feather feather-check text-white"></i> : 1}
  </div>

  <div className="bg-dark" style={{ height: "2px", width: "70px" }}></div>

  {/* Step 2 */}
  <div
    className="rounded-circle d-flex justify-content-center align-items-center"
    style={{
      height: "50px",
      width: "50px",
      backgroundColor: step > 2 ? '#1b84ff' : 'white',
      border: step === 2 ? '2px solid #1b84ff' : '1px solid lightblue',
      color: step > 2 ? 'white' : '#0d6efd',
      fontSize:"1.5rem"
    }}
  >
    {step > 2 ? <i className="feather feather-check text-white"></i> : 2}
  </div>

  <div className="bg-dark" style={{ height: "2px", width: "70px" }}></div>

  {/* Step 3 */}
  <div
    className="rounded-circle d-flex justify-content-center align-items-center"
    style={{
      height: "50px",
      width: "50px",
      backgroundColor: step > 3 ? '#1b84ff' : 'white',
      border: step === 3 ? '2px solid #1b84ff' : '1px solid lightblue',
      color: step > 3 ? 'white' : '#0d6efd',
      fontSize:"1.5rem",
    }}
  >
    {step > 3 ? <i className="feather feather-check text-white "></i> : 3}
  </div>

</div>

  </div>

  {/* Spacer for Fixed Header */}
  <div  style={{ height: "180px" }}></div>

{
  roleIdentifier==="SC" && existData?.appStatusLevel==="pendingAtHigherAuthorityApproval" && (
    <div className="border rounded p-3 mx-5 bg-white">
  <h4 className="fw-bold mb-3">Instructions for Submitting a Query / ક્વેરી સબમિટ કરવાની સૂચનાઓ</h4>

  <div className="row g-2">
    {/* Column 1 */}
    <div className="col-md-6">
      <div className="p-2 border rounded bg-white">
        <strong className='text-warning'>Verify</strong>: If the information is correct and no change is needed, click Verify.  
        <br />
        <span className="text-secondary">
          માહિતી સાચી હોય અને કોઈ બદલાવ જરૂરી ન હોય તો Verify દબાવો.
        </span>
      </div>
    </div>

    <div className="col-md-6">
      <div className="p-2 border rounded bg-white">
        <strong className='text-info'>Update</strong>: If changes are needed, click Update. Comment becomes mandatory.
        <br />
        <span className="text-secondary">
          બદલાવ કરવાની જરૂર હોય તો Update દબાવો. Comment ફરજિયાત થશે.
        </span>
      </div>
    </div>

    {/* Column 2 */}
    <div className="col-md-6">
      <div className="p-2 border rounded bg-white">
        <strong>Comment Only</strong>: Add a comment without verifying or updating.
        <br />
        <span className="text-secondary">
          Verify / Update વગર માત્ર Comment પણ લખી શકો છો.
        </span>
      </div>
    </div>

    <div className="col-md-6">
      <div className="p-2 border rounded bg-white">
        <strong className='text-success'>Submit</strong>: After verifying or updating, click Submit to save.
        <br />
        <span className="text-secondary">
          Verify અથવા Update પછી Submit દબાવી અંતિમ જવાબ સાચવો.
        </span>
      </div>
    </div>
  </div>

  <div className="alert alert-info p-2 mt-2 mb-0">
    <strong>Note:</strong> If no changes, always use Verify.  
    <br />
    <span className="text-secondary">નોંધ: બદલાવ ન હોય તો હંમેશાં Verify નો ઉપયોગ કરો.</span>
  </div>
</div>
  )
}

      
      {existData?.status === "approvedUnsigned" && (
  <>
   <div className="alert alert-info p-2  mx-4">
    <strong>Note:</strong> Download the Scheme to forward it to Higher Authority and then click on Forward button to change the status of application.  
    <br />
   
  </div>
  <div className="d-flex justify-center justify-item-center m-4">
    <SchemesDownload 
      pdfData={pdfData} 
      existData={existData} 
      applicationId={applicationId} 
    />

    <div className='d-flex justify-center justify-item-center m-4'>
      {/* <h3>Upload Scheme:</h3>
      <input
        type="file"
        className='form-control w-75'
        onChange={handleSelectedLicense}
        // style={{ marginBottom: "10px" }}
      /> */}
       {existData.schemeButtons  && existData?.schemeButtons.map((button) => (
            <button
                key={button.status}
                className={`btn ${
                button.status === "reject"
                    ? "btn-danger"
                    :  button.status === "permanentReject" ? "btn-secondary" : "btn-success"
                }  ms-3 `}
                onClick={() =>
      // handleUpload(name,file, fieldName ,docId );

                   handleFinalSubmit(button.status, button.appStatusLevel)
                }
                // disabled={isDisabled}
            >
                {button.buttonLabel}
            </button>
            ))}

    </div>
    </div>
  </>
)}

                     
    

  {/* Step Form Display */}
      {step === 1 && (
        <DistP1
        setExistData={setExistData}
          token={token}
          onNext={handleNext}
          formData={formData}
          handleFileChange={handleFileChange}
          handleInputChange={handleInputChange}
          handlePreviewFile={handlePreviewFile}
          editingIndex={editingIndex}
          setEditingIndex={setEditingIndex}
          editFieldValues={editFieldValues}
          handleEditChange={handleEditChange}
          editFiles={editFiles}
          handleEditFileChange={handleEditFileChange}
          editComment={editComment}
          setEditComment={setEditComment}
          hanldeFileInputChange={handleFileinputChange}
        
          applicationId={applicationId}
          // handleUpdateSubmit={handleUpdateSubmit}
          districtOptions={districtOptions}
          talukaOptions={talukaOptions}
          apmcOptions={apmcOptions}
          updatedFields={updatedFields}
          setUpdatedFields={setUpdatedFields}

          existData={existData}
          userDetail={userDetail}
          getExistedApplication={getExistedApplication}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          isValidationActive={isValidationActive}
          setIsValidationActive={setIsValidationActive}

          
        />
      )}
      {step === 2 && (
        <DistP2
        setExistData={setExistData}
          applicationId={applicationId}


        token={token}
        onNext={handleNext}
        onBack={handleBack}
        formData={formData}
        handleFileChange={handleFileChange}
        handlePreviewFile={handlePreviewFile}
        editingIndex={editingIndex}
        setEditingIndex={setEditingIndex}
        editFieldValues={editFieldValues}
        handleEditChange={handleEditChange}
        editFiles={editFiles}
        handleEditFileChange={handleEditFileChange}
        editComment={editComment}
        setEditComment={setEditComment}
        // handleUpdateSubmit={handleUpdateSubmit}
        updatedFields={updatedFields}
          setUpdatedFields={setUpdatedFields}

          existData={existData}
          userDetail={userDetail}
          getExistedApplication={getExistedApplication}
          validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        isValidationActive={isValidationActive}
        setIsValidationActive={setIsValidationActive}

      />

      )}
      {step === 3 && (
        <DistP3
        setExistData={setExistData}


        token={token}
          onBack={handleBack}
          formData={formData}
          handleFileChange={handleFileChange}
          handleInputChange={handleInputChange}
          handlePreviewFile={handlePreviewFile}
          editingIndex={editingIndex}
          setEditingIndex={setEditingIndex}
          editFieldValues={editFieldValues}
            hanldeFileInputChange={handleFileinputChange}
          handleEditChange={handleEditChange}
          editFiles={editFiles}
          handleEditFileChange={handleEditFileChange}
          editComment={editComment}
          setEditComment={setEditComment}
         handleEdInputChange={handleEdInputChange}
          assistanceDetails={assistanceDetails}
          setAssistanceDetails={setAssistanceDetails}
          updatedFields={updatedFields}
          setUpdatedFields={setUpdatedFields}
          transaction={transaction}
          existData={existData}
          userDetail={userDetail}
          applicationId={applicationId}
          getExistedApplication={getExistedApplication}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          isValidationActive={isValidationActive}
          setIsValidationActive={setIsValidationActive}
          siteInspectionPhotos={siteInspectionPhotos}
          inspectionPhotosChange={inspectionPhotosChange}
        />
      )}
           <ToastContainer position="top-left" autoClose={3000} />
            {uploadLoading && (
              <div className="position-fixed z-3 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0, 0, 0, 0.17)", zIndex: 1050 }}>
                <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
                  <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Uploading...</span>
                  </div>
                  <div className="fw-bold">Uploading, please wait...</div>
                </div>
              </div>
            )}
    </div>
    
  );
};
 
export default District;
